import { z } from 'zod';

export const arrayFromQuery = <T extends z.ZodTypeAny>(item: T) =>
    z
        .preprocess((v: unknown) => {
            const raw: unknown[] = v === undefined || v === null ? [] : Array.isArray(v) ? v : [v];

            return raw.filter(x => x !== '' && x !== undefined && x !== null);
        }, z.array(item))
        .default([]);
